/* Balthus · acciones del carrito: agregar sugerencia y convertir sueltas en paquete. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const post = (url, body) => fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; });
  const refresh = () => { document.dispatchEvent(new CustomEvent('cart:refresh:opend')); if (location.pathname.endsWith('/cart')) location.reload(); };
  document.addEventListener('click', async e => {
    const add = e.target.closest('[data-bal-add]');
    if (add && add.tagName === 'BUTTON') {
      const row = add.closest('.bal-cbt__row'), id = +row.querySelector('[data-bal-size]').value;
      add.disabled = true; add.textContent = '…';
      try { await post('cart/add.js', { items: [{ id, quantity: 1 }] }); add.textContent = '✓'; refresh(); }
      catch (err) { add.textContent = 'Agotada'; }
      return;
    }
    const cv = e.target.closest('[data-bal-convert]');
    if (cv) {
      cv.disabled = true; const txt = cv.textContent; cv.textContent = 'Armando tu paquete…';
      try {
        const updates = {}; cv.dataset.updates.split(';').filter(Boolean).forEach(p => { const i = p.lastIndexOf(':'); updates[p.slice(0, i)] = +p.slice(i + 1); });
        await post('cart/update.js', { updates });
        await post('cart/add.js', { items: [{ id: +cv.dataset.pack, quantity: 1, properties: { _bundle_selection: cv.dataset.hashes } }] });
        refresh();
      } catch (err) { cv.disabled = false; cv.textContent = txt; }
    }
  });
})();
